import {InputTextV2} from '@prtimes-basis/input';
import {Button} from '@prtimes-basis/button';
import styles from './zip-field.module.css';
import {
  FormField,
  useFormField,
} from '@/features/company-registration/steps/input-step/form-field';
import companyRegistrationPageStyles from '@/features/company-registration/styles.module.css';

type Props = {
  readonly onAutoFillAddress: () => void;
};

export function ZipField({onAutoFillAddress}: Props) {
  return (
    <FormField.Root name='companyInfo.zip'>
      <div className={styles.container}>
        <div className={styles.zipContainer}>
          <Body />

          <Button
            variant='flat'
            style={{height: '100%'}}
            onClick={onAutoFillAddress}
          >
            住所入力
          </Button>
        </div>

        <FormField.Error />

        <p className={styles.overseasNote}>
          FOR OVERSEAS CUSTOMERS：Please enter [0000000] in the postal code
          field.
        </p>
      </div>
    </FormField.Root>
  );
}

function Body() {
  const {fieldProps} = useFormField();

  return (
    <div>
      <label
        htmlFor={fieldProps.id}
        className={companyRegistrationPageStyles.srOnly}
      >
        本社所在地（郵便番号）
      </label>

      <InputTextV2
        required
        placeholder='郵便番号'
        wrapperClassName={styles.zipField}
        {...fieldProps}
      />
    </div>
  );
}
